import { render, staticRenderFns } from "./PlatformValue.vue?vue&type=template&id=761532de&scoped=true"
import script from "./PlatformValue.vue?vue&type=script&lang=js"
export * from "./PlatformValue.vue?vue&type=script&lang=js"
import style0 from "./PlatformValue.vue?vue&type=style&index=0&id=761532de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "761532de",
  null
  
)

export default component.exports